import { Card, Box, Icon, Text, SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './Panels.css';
import click from './sounds/shortclick.mp3';
import { FaCircle, FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';
import dso from './images/DSO.jpg';
import pumpoff from './images/PumpOff.png';
import flood from './images/FloodNormal.png';
import waterlevel from './images/WaterTank.png';

export default function FirePanels() {
    const tindex = useRef(1);
    const [dev, setDev] = useState([]);
    const [displayDev, setDisplayDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [selectedType, setSelectedType] = useState(1);
    const [buildingId, setBuildingId] = useState(1);
    const LargeCellText = "30px";

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    function handleClick(e) {
        console.log("Button clicked with value:", e); // Add this line
        playClickSound();
        setBuildingId(e);

    };

    // Create a connection to the hub
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    useEffect(() => {

        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };
        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        // Register a handler for receiving device data from the hub
        connection.on("ReceiveDeviceData", () => {
            // Update the state with the new device data
            console.log("Updating....")
            getData();
        });
    }, []);

    useEffect(() => {
        console.log("DisplayDev updated:", displayDev);
    }, [displayDev]);



    function CMiddleAndFireList() {
        if (!displayDev || displayDev.length === 0) {
            return <div>No devices to display</div>;
        }

        return (
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '4px' }}>
                <tbody>
                    <td colSpan="2" style={{ verticalAlign: 'top' }}>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '4px',
                            backgroundColor: '#888888',
                            borderRadius: '12px',
                            padding: '4px',
                            margin: '4px 0'
                        }}>
                            <h3 style={{
                                width: '100%',
                                padding: '8px',
                                margin: 0,
                                color: '#ffffff',
                                fontSize: '28px',
                                fontWeight: '600',
                                backgroundColor: '#ff7f27',
                                borderRadius: '8px'
                            }}>斑蝶樓</h3>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                            }}>
                                <td className="firepanellargecellstyle" style={{
                                    fontSize: "20px",
                                    overflow: "hidden",
                                    color: "#202020",
                                    backgroundColor: "#A2A2A2",
                                }}>
                                    <table>
                                        <tr style={{ height: "20px", fontWeight: "bold" }}>斑蝶樓消防控制台</tr>
                                        <tr>
                                            <td>消防控制屏2號 供電正常</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[11].status[1] === "1" ? "#00ff00" : "red" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>消防控制屏2號 火警</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[11].status[0] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>消防控制屏2號 故障</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[12].status[0] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>消防控制屏1號 供電正常</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[12].status[1] === "1" ? "#00ff00" : "red" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>消防控制屏1號 火警</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[13].status[0] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>消防控制屏1號 故障</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[13].status[1] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>花灑控制屏 供電正常</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[14].status[1] === "1" ? "#00ff00" : "red" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>花灑控制屏 火警</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[14].status[0] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>花灑控制屏 故障</td>
                                            <td>
                                                <FaCircle style={{ color: displayDev[15].status[0] === "1" ? "red" : "#00ff00" }} />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </div>
                        </div>
                    </td>
                </tbody>
            </table>
        );
    }

    function DList() {

        return (
            <div>
                <tr>
                    <td style={{ verticalAlign: "top" }}>
                        <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>
                            <tbody>
                                <CMiddleAndFireList />
                            </tbody>
                        </table>
                    </td>
                </tr>
            </div>
        )
    };

    return (
        <div className="containerstyle">
            <table>
                <td >

                    <div >
                        <table>
                            <tr style={{ verticalAlign: "top" }}>
                                <td style={{ verticalAlign: "top", width: "8%", height: "13.4rem" }}>
                                    <div>
                                        <div className="sidebarstyle" style={{ fontSize: "24px", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#6f4f4f" }} >
                                            消防泵狀態
                                        </div>
                                    </div>
                                </td>
                        
                                <td>
                                    <div>
                                        <table>
                                            <tr>
                                                <DList />

                                            </tr>
                                        </table>
                                    </div>
                                </td>
                                       
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );

}